import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

import speaker from "../../assets/images/contents/DrMazlanAbbas.jpg"

export const DrMazlanAbbas = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Dr Mazlan Abbas</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Dr Mazlan Abbas</b>
    </p>

    <p style={{textAlign:'center'}}>
        CEO & Co-Founder of FAVORIOT
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>IoT Analytics from Data to Decision Making - Trends & Challenges</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      IoT analytics covers data generated from devices in the Internet of Things (IoT). IoT Analytics helps users get insights and make better business decisions through data 
      analysis and decision making. IoT Analytics includes monitoring, analyzing, and reporting key indicators like device health, usage patterns, and performance. It is essential 
      to understand that IoT Analytics is not just about big data. It is more than that. IoT Analytics is all about the data and insights you get from it. There are many reasons 
      why the IoT Analytics market is growing so rapidly. IoT analytics helps in making sense of the data which is being generated from the connected devices. It also helps in 
      understanding how the data is being used. IoT analytics helps in improving the efficiency of operations. IoT analytics can also help in better decision-making. This enables 
      companies to understand their customers and competitors. The collected data can be used to identify an anomaly in the system and helps in identifying the problem areas and 
      improving them. With the help of IoT analytics, businesses can analyze the data from connected devices and provide better customer service. It can be achieved by understanding 
      the customer’s needs. In addition, the data can be used to track the customer’s behavior which helps in providing customized services. This keynote will cover some aspects of 
      trends and challenges of IoT analytics and show an example of how one can acquire data from sensors to conduct their own analytics.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
        Dr. Mazlan is the co-founder and CEO of FAVORIOT Sdn Bhd. He is ranked among Top 50 Global Thought Leaders on the Internet of Things (February 2019) and Digital 
        Disruption (October 2019) by Thinkers360, Top 50 Most Impactful Smart Cities Leaders by World CSR Congress 2017, ranked Top 10 in IoT Top 100 Influencers by Postscapes 
        2017 & 2018, ranked No. 20th Thought Leader in IOT by 2014 Onalytics Report – “The Internet of Things – Top 100 Thought Leaders” and UTM Alumni Industry Personality 2016. 
        Before FAVORIOT, he spent 2.5 years as CEO of REDtone IOT and 8 years in MIMOS Berhad as Senior Director Wireless Communications Cluster. He also spent 13 years in CELCOM 
        (mobile operator), handling many senior management positions. Prior to Celcom, he spent 10 years as an Assoc. Professor at Universiti Teknologi Malaysia. He was the Adjunct 
        Professor for UTM from 2008 to 2013, UTHM (2004-2005, 2013-2016), Universiti Teknologi Petronas (2018-2019) and Universiti Sultan Zainal Abidin (UniSZA) (2017-2018) and 
        Universiti Malaysia (UniMY) (2017-2019). Currently, he is the Adjunct Professor for MJIIT, UTM (2020-2022). Dr.Mazlan is a frequent speaker at many major & established IOT, 
        IR 4.0, Smart Cities and telco conferences locally and globally. He sits in the Industry Advisory Panel (IAP) for several local universities. He graduated from Universiti 
        Teknologi Malaysia with a BEE (1984), University of Essex (UK) with MSc. in Telematics (1986) and Universiti Teknologi Malaysia with a Ph.D. in Telecommunications (1993). 
        He also received an Honorary Doctorate in Electrical Engineering from UTHM (2017). He is also a TEDx Speaker.
    </p>

    <p style={{ textAlign:'justify'}}>Click this <b><a href = "https://mazlanabbas.com/about/" target="_blank">link</a></b> to see his further detail bio.<br/></p>

  </div>
)